import { FileViewerService } from './../../services/file-viewer.service';
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FileViewerComponent } from "../file-viewer/file-viewer.component";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { DxTooltipModule } from "devextreme-angular";

export interface DocumentPillValue {
  id: number | string;
  /** real filename, used to open the viewer */
  documentName: string;
  /** optional label shown on the pill; defaults to documentName */
  displayName?: string;
  /** file-viewer type, e.g. "task" or "property-file" */
  type: string;
  externallyModified?: boolean;
}
@Component({
    selector: "app-document-pill",
    imports: [CommonModule, SvgIconComponent, DxTooltipModule],
    templateUrl: "./document-pill.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./document-pill.component.css"]
})
export class DocumentPillComponent {

  @Input("value") value: DocumentPillValue | null = null;
  // ponytail: kept only because existing templates still bind it; the viewer opens in a new tab
  @Input("fileViewerRef") fileViewerRef: FileViewerComponent | null = null;

  constructor(private fileViewerService: FileViewerService) {}

  onPillClick() {
    // A row can render a filename before its file exists server-side (freshly inserted,
    // not yet saved). Without an id the viewer would open on `fileId=undefined`.
    if (!this.value?.id) return;

    this.fileViewerService.openOrDownloadFile(
      this.value.type,
      this.value.id,
      this.value.documentName,
      ''
    );
  }
}
